import R from 'ramda'
import React from 'react';
import autoBind from '../../modules/autoBind';

export default class Table extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      justSelected: null
    };
  }
  render() {
    const widthSum = R.compose(R.sum, R.map(R.prop('maxWidth')))(this.props.columns);
    return (
      <table className='table table-striped' style={{ width: '100%' }}>
        <thead>
          <tr style={{ cursor: 'pointer' }}>
            <For each='column' of={this.props.columns}>
              <th key={column.id} style={{ overflow: 'hidden', maxWidth: column.maxWidth / widthSum * 100 + '%' }} onClick={this.handleSort(column.id)}>
              {column.label}
              <span style={ this.props.sort.column === column.id && this.props.sort.order === 'asc' ? { transform: 'rotate(180deg)' } : {} } className={this.props.sort.column === column.id ? 'caret' : ''} />
            </th>
            </For>
          </tr>
        </thead>
        <tbody>
          <For each='row' of={this.props.data} index='index'>
            <tr key={index} style={this.props.selectedIndex === index ? { backgroundColor: '#5BC0DE' } : {}} onClick={this.handleRowClick(index)}>
              <For each='column' of={this.props.columns}>
                <td key={column.id}>{row[column.id]}</td>
              </For>
            </tr>
          </For>
        </tbody>
      </table>
    );
  }
  handleSort(column) {
    return () => this.props.onSort({
      column,
      order: column === this.props.sort.column && this.props.sort.order === 'desc' ? 'asc' : 'desc'
    });
  }
  handleRowClick(index) {
    return () => {
      if (this.state.justSelected) {
        clearTimeout(this.state.justSelected[1]);
      }
      if (this.state.justSelected && this.state.justSelected[0] === index) {
        this.props.onRowDoubleClick({ row: this.props.data[index], index });
      } else {
        const timeoutId = setTimeout(() => this.setState({ justSelected: null }), 500);
        this.props.onRowClick({ row: this.props.data[index], index });
        this.setState({ justSelected: [index, timeoutId] });
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/App/users/Table.jsx